export default "__VITE_ASSET__654947b9__"